module.exports = __webpack_public_path__ + "static/media/logo1.6a23d17c.png";